import React from "react";
import { Link } from "../../utils/customLink";
import DownloadSvg from "../../images/icons/fi-rr-download.inline.svg";
import ArrowDownIcon from "../../images/icons/arrow-down-icon.inline.svg";
import ArrowRightIcon from "../../images/icons/arrow-right-icon.inline.svg";

const DownloadCTA = ({ to = "#", ctaLabel, type = "Download" }) => {
  return (
    <Link
      to={to}
      target={"_blank"}
      rel={"noopener"}
      className={`group relative z-10 flex flex-row items-center justify-center 
                px-2 py-2 rounded-full planet:rounded-sm
                text-white planet:text-gray-darker  
                bg-white planet:bg-gray-darkest
                hover:bg-black-lighter planet:hover:bg-white 
                border border-black-lighter planet:border-white`}
    >
      <p className="text-base leading-genericCta font-bold pr-2 text-black-lighter planet:text-white group-hover:text-white planet:group-hover:text-gray-darker">
        {ctaLabel}
      </p>
      {type === "Download" && (
        <DownloadSvg className="w-5 pr-1 fill-black-lighter planet:fill-white group-hover:fill-white planet:group-hover:fill-gray-darker" />
      )}
      {type === "DownloadIcon" && (
        <ArrowDownIcon className="fill-black-lighter planet:fill-white group-hover:fill-white group-hover:stroke-white planet:group-hover:stroke-gray-darker" />
      )}

      {type === "ArrowDown" && (
        <ArrowRightIcon className="stroke-black-lighter planet:stroke-white group-hover:stroke-white planet:group-hover:stroke-gray-darker rotate-90" />
      )}
    </Link>
  );
};

export default DownloadCTA;
